import moment from 'moment';
import * as types from '../../constants/actionsType'
import Colors from '../../../utils/constants/Colors';

const initialState = {
    isLoadingAttendance: false,
    attendanceTableData: {
        headmonth: [],
        head: [],
        body: [],
        footer: []
        // footer: [
        //     [1, "Melvin", 20, 16, 11, 11, 11, 11, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 44, 44, 66, 24, "100%"],
        //     [1, "Melvin", 20, 16, 11, 11, 11, 11, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 66, 44, 44, 66, 24, "100%"],
        // ]
    },
    attendanceCard: [],
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.LOADING_ATTENDANCE:
            return {
                ...state,
                isLoadingAttendance: action.data
            }
        case types.SUCCESS_ATTENDANCE:
            var summary = [{
                name: "Selected Period",
                unitBefore: action.data.attendanceSummary[0].period,
                unitAfter: '',
                size: 3,
                icon: "Period",
                background: 'rgba(87,113,219,0.05)'
            },
            {
                name: 'Total Working Days',
                unitBefore: action.data.attendanceSummary[0].totalWork,
                unitAfter: '',
                size: 3,
                icon: "Desk",
                background: 'rgba(87,113,219,0.05)'
            },
            {
                name: 'Holidays',
                unitBefore: action.data.attendanceSummary[0].holiday,
                unitAfter: '',
                size: 3,
                icon: "Holiday",
                background: 'rgba(87,113,219,0.05)'
            },
            {
                name: 'Average Attendance',
                unitBefore: action.data.attendanceSummary[0].averageAttendance != "" ? action.data.attendanceSummary[0].averageAttendance + "%" : action.data.attendanceSummary[0].averageAttendance,
                unitAfter: '',
                size: 3,
                icon: "Attendance",
                background: 'rgba(87,113,219,0.05)'
            }]
            var header = []
            header.push({ label: "Rank", align: "left" })
            header.push({ label: "Name", align: "left" })
            header.push({ label: "Emp Code", align: "left" })
            header.push({ label: "Business Unit", align: "left" })
            header.push({ label: "Department", align: "left" })
            header.push({ label: "Job Role", align: "left" })
            header.push({ label: "Designation", align: "left" })
            header.push({ label: "Location", align: "left" })


            const uniqueID = action.data.attendanceDataList.filter((ele, ind) => ind === action.data.attendanceDataList.findIndex(elem => elem.authId === ele.authId && elem.authId === ele.authId));

            var headerValue = []
            headerValue.push({ label: "Rank", align: "left" })
            headerValue.push({ label: "Name", align: "left", isFilter: true, filterVal: null, index: 1 })
            headerValue.push({ label: "Emp Code", align: "left" })

            headerValue.push({ label: "Business Unit", align: "left", isFilter: true, filterVal: null, index: 2 })
            headerValue.push({ label: "Department", align: "left", isFilter: true, filterVal: null, index: 3 })
            headerValue.push({ label: "Job Role", align: "left", isFilter: true, filterVal: null, index: 4 })
            headerValue.push({ label: "Designation", align: "left", isFilter: true, filterVal: null, index: 5 })
            headerValue.push({ label: "Location", align: "left", isFilter: true, filterVal: null, index: 6 })

            action.data.attendanceDataList
                .filter(i => {
                    if (uniqueID.length > 0 && uniqueID[0].authId == i.authId) {
                        //header.push({ label: i.headerDate, align: "center" })
                        return { ...i }
                    }
                }
                ).sort((a, b) => new Date(a.date) - new Date(b.date)).map((i, index) => {

                    (headerValue.push({ label: i.headerDate, align: "center", isDate: "true", month: i.headerDate.substring(0, 3), day: i.headerDate.substring(4, 6) }
                    ))

                })
            var previousDate = ""
            var count = 0
            for (var i = 8; i <= headerValue.length - 1; i++) {

                if (i == 8) {
                    previousDate = headerValue[i].label.substring(0, 3)
                }
                if (headerValue[i].label.substring(0, 3) == previousDate) {
                    count += 1
                    if (i == headerValue.length - 1) {
                        count += 1
                        header.push({ month: previousDate, day: headerValue[i].label.substring(4, 6), isDate: "true", colSpan: count })
                        count = 0
                    }
                }
                else {
                    count += 1
                    header.push({ month: previousDate, day: headerValue[i].label.substring(4, 6), isDate: "true", colSpan: count })
                    count = 0
                }
                previousDate = headerValue[i].label.substring(0, 3)
            }
            headerValue.push({ label: "Attended", align: "center" })
            headerValue.push({ label: "Attended %", align: "center" })
            header.push({ label: "Attended", align: "center" })
            header.push({ label: "Attended %", align: "center" })
            var data = uniqueID.map(i => {
                return { id: i.authId, child: action.data.attendanceDataList.filter(value => value.authId == i.authId) }
            })

            var body = []
            var bodyValue = data.map(i => {
                var dayValue = []
                var day = headerValue.map(value => {
                    return (i.child.map(j => {
                        if (j.headerDate == value.label) {
                            dayValue.push(j)
                        }
                    })
                    )
                })
                return {
                    id: i.id,
                    child: dayValue
                }
            })

            bodyValue.map((item) => {
                var attendanceArr = []
                if (item.child.length > 0) {
                    item.child.map((i) => {
                        attendanceArr.push({ isDay: true, isAttendance: i.isPresent, isHoliday: i.isHoliday, isWeekEnd: i.isWeekEnd, date: i.date, headerDate: i.headerDate, thresHold: i.thresHold, isOT: i.isOT, otHrs: i.otHrs })
                    })
                    body.push([item.child[0].authId, item.child[0].name, item.child[0].businessUnit, item.child[0].department, item.child[0].role, item.child[0].designation, item.child[0].location, attendanceArr, item.child[0].empCode == undefined ? "" : item.child[0].empCode])
                }
            })

            var finalBody = []
            body.map(item => {
                var datas = []
                var finalData = []
                action.data.userDayRequiredAttendance.map(att => {
                    if (att.authId == item[0]) {
                        datas.push(att.rank)
                        datas.push({ name: item[1] })
                        datas.push({ empCode: item[8] })
                        datas.push({ businessUnit: item[2], isHide: true })
                        datas.push({ department: item[3], isHide: true })
                        datas.push({ role: item[4], isHide: true })
                        datas.push({ designation: item[5], isHide: true })
                        datas.push({ location: item[6], isHide: true })
                        headerValue.filter((i, index) => (index >= 8 && index < headerValue.length - 2)).map((item, index) => {
                            datas.push(item.label);
                        })
                        for (var i = 0; i < headerValue.length - 10; i++) {
                            var attrIndex = datas.indexOf(item[7][i]?.headerDate)
                            datas[attrIndex] = item[7][i]
                        }

                        datas.push({ attended: att.availableCount })
                        datas.push({ attendedPer: att.percentage })
                        // datas.push({ attendedPer: att.percentage + "%" })

                        datas.map(i => {
                            if (typeof i != 'string') {
                                finalData.push(i)
                            }
                            else {
                                finalData.push({ isDay: true, isAttendance: false, isHoliday: false, isWeekEnd: false, thresHold: false, isOT: false })
                            }
                        })
                        finalBody.push(finalData)
                    }
                })

            })

            var attendedDatas = []
            var attendedPerDatas = []
            attendedDatas.push("")
            attendedPerDatas.push("")
            attendedDatas.push("Attended")
            attendedPerDatas.push("Attended %")
            attendedDatas.push("")
            attendedPerDatas.push("")
            attendedDatas.push({ isHide: true })
            attendedPerDatas.push({ isHide: true })
            attendedDatas.push({ isHide: true })
            attendedPerDatas.push({ isHide: true })
            attendedDatas.push({ isHide: true })
            attendedPerDatas.push({ isHide: true })
            attendedDatas.push({ isHide: true })
            attendedPerDatas.push({ isHide: true })
            attendedDatas.push({ isHide: true })
            attendedPerDatas.push({ isHide: true })
            headerValue.filter((i, index) => (index >= 8 && index < headerValue.length - 2)).map((item, index) => {
                attendedDatas.push(item.label);
                attendedPerDatas.push(item.label)
            })
            action.data.userRequiredAttendance.map(attAvl => {
                //var matches = attAvl.headerDate.match(/(\d+)/);
                var attendanceIndex = attendedDatas.indexOf(attAvl.headerDate)
                var attendancePerIndex = attendedPerDatas.indexOf(attAvl.headerDate)
                attendedDatas[attendanceIndex] = { attended: attAvl.availableCount };
                attendedPerDatas[attendancePerIndex] = { attendedPer: attAvl.percentage };
            })
            attendedDatas.push("")
            attendedPerDatas.push("")
            attendedDatas.push("")
            attendedPerDatas.push("")

            var finalAttendedData = []
            var finalAttendedPerData = []
            attendedDatas.map((j) => {
                if (typeof j != 'string') {
                    finalAttendedData.push(j)
                }
                else {
                    if (j == "Attended" || j == "Attended %" || j == "") {
                        finalAttendedData.push(j)
                    }
                    else {
                        finalAttendedData.push({ attended: "0" })
                    }
                }
            })
            attendedPerDatas.map((j) => {
                if (typeof j != 'string') {
                    finalAttendedPerData.push(j)
                }
                else {
                    if (j == "Attended" || j == "Attended %" || j == "") {
                        finalAttendedPerData.push(j)
                    }
                    else {
                        finalAttendedPerData.push({ attendedPer: "0" })
                    }
                }
            })
            // finalBody.push(finalAttendedData)
            // finalBody.push(finalAttendedPerData)
            var footer = []
            footer.push(finalAttendedData)
            footer.push(finalAttendedPerData)
            return {
                ...state,
                attendanceCard: summary,
                attendanceTableData: {
                    headmonth: header.length > 9 ? header : headerValue,
                    head: headerValue,
                    body: finalBody.sort((a, b) => a[0] - b[0]),
                    footer: footer
                }
            }
        default:
            return state
    }
}
export default reducer